import { Text, View } from '@react-pdf/renderer';
import type { Style } from '@react-pdf/types';
import type { ReactElement } from 'react';

export type PdfTextBlockProps = {
  content: string;
  viewStyle?: Style;
  textStyle?: Style;
};

export const PdfTextBlock = ({
  content,
  viewStyle,
  textStyle,
}: PdfTextBlockProps): ReactElement => (
  <View style={viewStyle}>
    <Text style={textStyle}>{content}</Text>
  </View>
);
